import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { timeout, catchError } from 'rxjs/operators';

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
  constructor() {}

  private readonly TIMEOUT_DURATION = 60000; // 60 seconds

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      timeout(this.TIMEOUT_DURATION), // Apply global timeout
      catchError((error) => {
        if (error.name === 'TimeoutError') {
          console.error('Request timed out:', req.url);
          return throwError(
            () => new Error('Request timed out, please try again')
          );
        }
        return throwError(() => error); // Rethrow other errors
      })
    );
  }
}
